const createGooglePlacesSessionToken = () => {
  let token = new window.google.maps.places.AutocompleteSessionToken();

  const renew = () =>
    (token = new window.google.maps.places.AutocompleteSessionToken());

  const getToken = () => token;

  const getTokenAsString = () => {
    const tokenString = token.token;
    if (!tokenString) {
      // eslint-disable-next-line no-console
      console.warn(
        '[PlacesAutocomplete] Failed to read session token string from AutocompleteSessionToken; autocomplete and Place Details will be billed as separate requests.'
      );
    }
    return tokenString;
  };

  return {
    renew,
    getToken,
    getTokenAsString
  };
};

export default createGooglePlacesSessionToken;
